import { SandboxTiles } from "components/loading-sandbox-list/SandboxTiles";
import { PlaygroundLoader } from "components/playground/PlaygroundLoader";
import { useComponentEngagement } from "hooks/useComponentEngagement";
import { useEffect, useState } from "react";
import { sandboxApi } from "services/sandbox-api/api";
import { TrackedSandboxEvent, useTrackSandboxEvent } from "services/telemetry-service/telemetry";
import { CodeShareMetadata } from "types";
import { ExpandableBlock } from "@itwin/itwinui-react";
import styles from "./FeaturedSandboxesView.module.css";

export const FeaturedSandboxesView = () => {
  const [sandbox, setSandbox] = useState<CodeShareMetadata>();
  const { data: featuredSandboxes, isLoading } = sandboxApi.useCodeSharesFeaturedQuery();
  const trackEvent = useTrackSandboxEvent<TrackedSandboxEvent>("Featured sandbox selection click");

  useComponentEngagement("Featured");

  const onSandboxSelected = (sandbox: CodeShareMetadata) => {
    setSandbox(sandbox);
    trackEvent({ SandboxName: sandbox.name, SandboxUser: sandbox.username, SandboxUserId: sandbox.userId, SandboxId: sandbox.id });
  }

  useEffect(() => {
    if (featuredSandboxes && featuredSandboxes.length)
      setSandbox(featuredSandboxes[0]);
  }, [featuredSandboxes])

  return (
    <div className={styles.container}>
      <ExpandableBlock title="Featured Sandboxes" styleType="borderless" isExpanded={true} className={styles.featured} data-testid="atp-featured-sandboxes">
        <div className={styles.list}>
          <SandboxTiles list={featuredSandboxes} isLoading={isLoading} onClick={onSandboxSelected} active={sandbox} showStats={true} emptyMessage="No sandboxes available" />
        </div>
      </ExpandableBlock>
      {sandbox && <PlaygroundLoader sandboxName={sandbox.name} userName={sandbox.username} viewTestId="atp-featured-sandbox-view" />}
    </div>
  )
}